module.exports = __webpack_public_path__ + "assets/img/step2-2.40e9667f.png";